import { render, staticRenderFns } from "./LanguageSelectBox.vue?vue&type=template&id=9bc706ee&scoped=true"
import script from "./LanguageSelectBox.vue?vue&type=script&lang=js"
export * from "./LanguageSelectBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc706ee",
  null
  
)

export default component.exports